export function formatCurrency(
  value: number | null,
  currency: string | null,
  locale: string
): string | null {
  if (value === null || currency === null || currency.trim().length === 0) return null;

  try {
    return new Intl.NumberFormat(locale, {
      currency: currency.trim().toUpperCase(),
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
      style: 'currency',
    }).format(value);
  } catch {
    return null;
  }
}
